import { Component, OnInit } from '@angular/core';
import { Locations } from '../models/locationList';
import { MapService } from '../services/map.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {

 

  locationList: Array<Locations> = new Array<Locations>();
	routes: any[];
	headerCounts: any[];
	selRoutes: Array<any> = new Array<any>();
	custInfo: Array<any> = new Array<any>();
	ddlLocation: any = 0;
	routeSequence:any;
	selRouteSeq:string;

  constructor(private mapServices:MapService) { }
  datePicker:any;
  selDateTime:string;
  lat = 12.9706111;
  lng = 77.5152329;
  panelsList = {
    "OverView": true,
    "RouteDetails": false,
    "Complains":false,
    "Drivers":false,
  }
  panelVisList = {
    "All": true,
    "Pending": false,
    "Cash":false,
    "Complete":false,
    "Issues":false
  }

  async ngOnInit(){
    // let loader = new Loader({
    //   apiKey:null//'BKIzaSyBHIflGoVogygEQCrOvd44OLgbvQbr3RVE',//'423ccb23e49e0ec8'
    // });

    // loader.load().then((res)=>{
    //   new google.maps.Map(document.getElementById('map'),{
    //     center:{lat:this.lat,lng:this.lng},
    //     zoom:6,
    //     mapId:'7fb117502e5d4d20D'
    //   })
    // })

    
    this.datePicker = {year:new Date().getFullYear(),month:(new Date().getMonth()+1),day:new Date().getDate()};
		const event = new Date(this.datePicker.year+"-"+this.datePicker.month+"-"+this.datePicker.day);

		this.selDateTime = event.toLocaleDateString('en-IN', { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' });
		this.selDateTime = this.selDateTime.split(',')[0] + ", " + this.selDateTime.split(',')[1] + " " + this.selDateTime.split(',')[2];
		// this.datePicker = {year:new Date().getFullYear(),month:(new Date().getMonth()+1),day:new Date().getDate()};
		
		await this.getLocationsList();
		await this.refreshAllApiCall();
  }

  // ngAfterViewInit(){
  //   const uluru ={lat:this.lat,lng:this.lng};
  //   // The map, centered at Uluru
  //   // const map = new google.maps.Map(
  //   //   document.getElementById("map") as HTMLElement,
  //   //   {
  //   //     zoom: 4,
  //   //     center: uluru,
  //   //   }
  //   // );

  //   // The marker, positioned at Uluru
  //   const marker = new google.maps.Marker({
  //     position: uluru,
  //     map: new google.maps.Map(
  //       document.getElementById("map") as HTMLElement,
  //       {
  //         zoom: 4,
  //         center: uluru,
  //       }
  //     )
  //   });
  // }
 //to shift ot move panels in click
 toggleMainPanel(nPanel){
this.panelsList={
  "OverView": false,
  "RouteDetails": false,
  "Complains":false,
  "Drivers":false,
}
this.panelsList[nPanel] = true;
 }
 togglePanel(nextPanel) {
  this.panelVisList = {
    "All": false,
    "Pending": false,
    "Cash":false,
    "Complete":false,
    "Issues":false
  }
  this.panelVisList[nextPanel] = true;
}

  ckDate(){
    const event = new Date(this.datePicker.year+"-"+this.datePicker.month+"-"+this.datePicker.day);
    this.selDateTime = event.toLocaleDateString('en-IN',{ weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' });
    this.selDateTime = this.selDateTime.split(',')[0]+", "+this.selDateTime.split(',')[1]+" "+this.selDateTime.split(',')[2];
    this.refreshAllApiCall();
  }

  async getLocationsList(){
    try{
      var res = await this.mapServices.getLogisticLocations('JB','JBT04',0);
      if(!res.error){
        debugger;
        this.locationList = <Array<Locations>>res.data;
      }
      else{
        alert(res.message);
      }
    }
    catch(err){
      console.log(err);
      alert('Someting went wrong while fetching data');
    }
  }

  async getRoutesCode(){
    try{
      var res = await this.mapServices.getRouteCodes('JB','JBT04',0,20220209);
      if(!res.error){
        this.routes = res.data;
      }
      else{
        alert(res.message);
      }
    }
    catch(err){
      console.log(err);
      alert('Someting went wrong while fetching data');
    }
  }

  async getHeaderCounts(){
    try{
      var res = await this.mapServices.getCounts('JB','JBT04',0,20220209);
      if(!res.error){
        this.headerCounts = res.data;
      }
      else{
        alert(res.message);
      }
    }
    catch(err){
      console.log(err);
      alert('Someting went wrong while fetching data');
    }
  }

  getHeaderCountByText(textName){
    if(this.headerCounts!=undefined && this.headerCounts.length>0 && this.headerCounts.filter(m=>m.TEXT==textName).length==1){
      return this.headerCounts.filter(m=>m.TEXT==textName)[0].TOTAL;
    }
    else{
      return 0;
    }
  }

  // ----------------- API addin-----------------
  async fetchCusDetails(event: any, routeCode) {
		if (event.target.checked) {
			this.selRoutes.push(routeCode);
			await this.getCustByRouteNo();
		}
		else {
			this.selRoutes = this.selRoutes.filter(m => m != routeCode);
			this.getCustByRouteNo();
		}
	}

	async getCustByRouteNo() {
		try {
			var res = await this.mapServices.getCustomerInfoByRoute('JB', 'JBT04', parseInt(this.ddlLocation), this.getSelDateInNumber(), this.selRoutes.join(','));
			if (!res.error) {
				this.custInfo = res.data;
				debugger;
			}
			else {
				alert(res.message);
			}
		}
		catch (err) {
			console.log(err);
			alert('Failed to fetch customer info');
		}
	}

	async locChanged() {

		await this.refreshAllApiCall();
	}

	getSelDateInNumber(): number {
		var year = this.datePicker.year;
		var month = this.datePicker.month < 10 ? '0' + this.datePicker.month : this.datePicker.month;
		var day = this.datePicker.day < 10 ? '0' + this.datePicker.day : this.datePicker.day;

		return parseInt(year + month + day);
	}

	async getRouteScanning(route){
		try{
			this.selRouteSeq = route;
			var res = await this.mapServices.getRouteSequencey('JB', 'JBT04', parseInt(this.ddlLocation), this.getSelDateInNumber(),route);
			if(!res.error){
				this.routeSequence = res.data;
			}
			else{
				alert(res.message);
			}
		}
		catch(err){
			console.log('Failed to fetch route sequence');
		}
	}

	getScannedSequenceByName(name){
		if(this.routeSequence!=undefined && this.routeSequence!=null){
			var returnValue = this.routeSequence.filter(m=>m.TEXT==name).length>0?this.routeSequence.filter(m=>m.TEXT==name)[0].TOTAL:0;
			return returnValue;
		}
		else{
			return 0;
		}
	}

	async refreshAllApiCall(){
		await Promise.all([
			this.getRoutesCode(),
			this.getHeaderCounts(),
			this.getCustByRouteNo()
		]);
	}
}
